define('models/shared/network/network_collection',["backbone",
        "models/shared/network/network"
], function (Backbone, NetworkItem) {
    var NetworkList = Backbone.Collection.extend({
        url: function () {
            var url = pf.consumerURL + "/Network";
            //if (this.includeEvents) {
                if (this.profileGUID) {
                    url += "/?includeEvents=false&profileGUID=" + this.profileGUID;
                }
                else {
                    url += "/?includeEvents=true";
                }
                url += "&mgrOnly=" + this.mgrOnly + "&mgrAndCoMgr=" + this.mgrAndCoMgr;
            //}

            return url;
        },
        model: NetworkItem,
        initialize: function (options) {
            options = options || {};
            this.profileGUID = options.profileGUID;
            this.includeEvents = options.includeEvents;
            this.mgrOnly = options.mgrOnly != null ? options.mgrOnly : false;
            this.mgrAndCoMgr = options.mgrAndCoMgr != null ? options.mgrAndCoMgr : false;
        }
    });
    return NetworkList;
});

